"use client";

import { useQueryState } from "nuqs";

import { MODE_QUERY_KEY, modeParser } from "@demo/constants/mode";

/**
 * Read/update the active mode in the `?mode=` query param. Client-side and
 * shallow by nuqs default, so switching updates the URL without a server
 * round-trip. Returns `[mode, setMode]`.
 */
export const useMode = () => useQueryState(MODE_QUERY_KEY, modeParser);
